import { Sun, Moon, Monitor, Check } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import { restaurantConfig } from "../config/restaurantConfig";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const ICONS = { light: Sun, dark: Moon, system: Monitor };

export default function ThemeToggle() {
  const { mode, resolved, setMode } = useTheme();
  const cfg = restaurantConfig.ui.themeToggle;
  const TriggerIcon = resolved === "dark" ? Moon : Sun;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="theme-toggle-btn"
        aria-label={cfg.aria}
        className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-border/60 hover:border-accent-line transition-colors text-foreground/80 hover:text-accent-line"
      >
        <TriggerIcon className="w-4 h-4" strokeWidth={1.5} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        data-testid="theme-toggle-menu"
        className="min-w-[180px] rounded-none border border-border bg-popover/95 backdrop-blur-md p-1"
      >
        {cfg.options.map(({ value, label }) => {
          const OptIcon = ICONS[value];
          return (
            <DropdownMenuItem
              key={value}
              data-testid={`theme-option-${value}`}
              onClick={() => setMode(value)}
              className="cursor-pointer rounded-none flex items-center gap-3 px-3 py-2 text-xs tracking-luxe-sm uppercase font-sans focus:bg-accent-line/10 focus:text-accent-line"
            >
              <OptIcon className="w-3.5 h-3.5" strokeWidth={1.5} />
              <span className="flex-1">{label}</span>
              {mode === value && <Check className="w-3.5 h-3.5 text-accent-line" strokeWidth={2} />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
